import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function handleFormSubmitApiError(error: any, t: Function) {
    if (error instanceof Error) {
        alert(error.message || t('Form.failedToSubmit'));
    } else alert(t('Form.unknownError'));
}

export function isMobileDevice() {
    return /Mobi|Android/i.test(navigator.userAgent);
}

export function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
